export enum recurrenceType {
    Hourly = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
}
